<template>
  <b-modal :id="modalId"
           title="Политика конфиденциальности"
           hide-footer
           centered
           size="xl">
    <p>{{ PRIVACY_TEXT }}</p>
  </b-modal>
</template>

<script>
  import { PRIVACY_TEXT } from '../privacy-text';

  export default {
    name: 'ModalPrivacy',
    data() {
      return {
        'modalId': 'modal-privacy',
        PRIVACY_TEXT,
      }
    },
  }
</script>

<style lang="scss">
  #modal-privacy {
    p {
      white-space: pre-wrap;
    }
  }
</style>
